export default {
  onboarding: {
    'profile-live': {
      title: 'Your profile is now live!',
      description: 'Your clients can now see your profile and make bookings online. Make sure you are ready to go by following these steps. Booksy will continue to support your journey as you go with helpful tips and guides.',
    },
    'profile-not-live': {
      'days-title': 'Your profile will go live in {count} day | Your profile will go live in {count} days | Your profile will go live in {count} days',
      'soon-title': 'Your profile will go live soon',
      description: 'Once you go live your clients will be able see your profile and make bookings online. Make sure you are ready to go by following these steps. Booksy will continue to support your journey as you go with helpful tips and guides.',
    },
    topics: {
      profile: {
        title: 'Polish your profile images',
        subtitle: 'Add an eye-catching cover photo and logo to attract clients.',
      },
      portfolio: {
        title: 'Build strong portfolio',
        subtitle: 'Show clients what they can expect by adding images of your previous work and increase your chances of getting booked.',
      },
      services: {
        title: 'Check your services',
        subtitle: 'Add information about the services you offer alongside photos and prices.',
      },
      'business-details': {
        title: 'Add important business details',
        subtitle: 'Add your business hours, location and any other important information clients may need to be aware of.',
      },
    },
    'confirm-button-label': 'Got it!',
    'preview-button-label': 'Preview Profile',
    'profile-button-label': 'View Profile',
  },
  marketing: {
    tools: {
      title: 'Use marketing tools to activate your clients',
      description: 'Engage current clients and attract new ones with ready-to-use templates and tools to simplify your marketing.',
    },
    spc: {
      title: 'Use Social Media Marketing to build your online presence',
      description: 'Connect with clients on social media to encourage new bookings.<br /><br />Save time and simplify your social media strategy by choosing from a collection of ready-made templates to share your work, reviews, special events and more.',
    },
    blasts: {
      title: 'Keep everyone in the loop with Text and Email Marketing',
      description: 'Enable automatic messages to keep your clients up to date. Want to share news about your business or just wish your clients a happy birthday? Use ready-made templates or build your own custom messages.',
    },
    promotions: {
      title: 'Attract new clients with Promotions',
      description: `Who doesn't love a discount? Create happy clients and fill your calendar by using Promotions tailored to your business.`,
    },
    community: {
      title: 'Grow your community',
      description: 'Invite your existing clients, or generate a link to your business profile to start building your community.',
    },
  },
  spc: {
    templates: {
      title: 'Create custom posts and graphics with our Social Media Marketing feature ',
      description: 'Try out a selection of ready-made message templates, designed for every occasion and encourage your followers to book online.',
    },
    instagram: {
      title: 'Use Instagram Reels to get higher engagement',
      description: 'Upload multiple photos and create a Reel to boost engagement and draw the attention of your followers.',
    },
    'online-groups': {
      title: 'Keep the conversation flowing',
      description: 'Online groups are a great way to build relationships with other business owners and influencers in your area as well as the clients you’re trying to attract.',
    },
  },
  'get-started': 'Get started',
}
